module.exports = __webpack_public_path__ + "img/flip-2.927393a8.png";